<template>
  <div class="login-container">
    <div class="login-form-con">
      <div class="login-title">炜凯智能云平台</div>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="login-form">
        <el-form-item label="用户名" prop="pass">
          <el-input v-model="ruleForm.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item class="login-btn">
          <el-button type="primary" @click="submitForm('ruleForm')">登陆</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="copyright ">
      <div>Copyright <span class="copyright-a">©</span> 2020-{{nowYear}} 青岛炜凯智能自动化科技有限公司. All Rights Reserved.</div>
      <div><a href="http://beian.miit.gov.cn">鲁ICP备2020041584号</a>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37020302371868"
           style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-left:8px">鲁公网安备37020302371868号</a></div>
    </div>
  </div>
</template>

<script>
    import localCache from '../../util/localCache'
import {login} from '../../api/user'
export default {
name: "login",
  data() {
    return {
      ruleForm: {
        userName: '',
          password: '',
      },
      rules: {
          userName: [
              { required: true, trigger: 'blur' },
              { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' }
        ],
          password: [
              { required: true, trigger: 'blur' },
              { min: 8, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' }
        ]
      },
      nowYear: new Date().getFullYear()
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          login(this.ruleForm).then((res)=>{
              if(res.errorcode==0){
                  console.log(res)
                  let data = res.data

                  localCache.setToken(data.token)
                  localCache.setUser(data.user)
                  localCache.setRole(data.role)
                  localCache.setCustomer(data.customer)
                  localCache.setCurrentCustomerId(data.user.customerId)
                  localCache.clearMenus()
                  this.$router.replace({path: '/index'})
              }else{
                  this.$message({
                      message: res.message,
                      type: 'error'
                  })
              }
          })

        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style lang="scss">
  .login-container{
    width: 100vw;
    height: 100vh;
    background: url("../../assets/login_bg.jpg") no-repeat;
    background-size: 100% 100%;
    position: relative;
    .login-title{
      font-size: 25px;
      text-align: left;
      color: #fff;
      padding: 15px;
      border-bottom: #fff thin solid;
      margin-bottom: 15px;
    }
    .login-form-con{
      position: absolute;
      background-color: rgba(255,255,255,0.5);
      width: 550px;
      top: 30vh;
      left: calc(50% - 225px);
      border-radius: 5px;

    }
    .login-form .el-input {
      width: 360px !important;
    }
    .login-form .el-input__inner{
      height: 55px !important;
      line-height: 55px !important;
    }
    .login-btn{
      text-align: center;
      margin-left: -100px;
    }

    .copyright {
      position: absolute;
      bottom: 15px;
      width: 100%;
      text-align: center;
      color: #c7c4c4;
      line-height: 25px;
      .copyright-a{
        font-size: 20px;
        vertical-align: middle;
      }
      a{
        color:#c7c4c4;
      }
    }
  }


</style>